import React, { useState } from 'react';
import { Button, Form, Input, message } from 'antd';

import { FormsService } from '../../../API/FormsService';

import styles from '../Form.module.css';

export default function FormAdd() {
    const [form] = Form.useForm();
    const [newForm, setNewForm] = useState({});
    const [isFildsFill, setIsFildsFill] = useState(false);
    const [loading, setLoading] = useState(false);

    const onValuesChange = (changedValues, allValues) => {
        setNewForm(prev => {
            return { ...prev, ...allValues };
        });

        if (allValues?.id?.length > 0 && allValues?.name?.length > 0) {
            setIsFildsFill(true);
        } else {
            setIsFildsFill(false);
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();

        setLoading(true);

        const data = await FormsService.setForm(newForm, message);
        if (data) {
            setLoading(false);
            setIsFildsFill(false);
            form.resetFields();
        } else {
            setLoading(false);
        }
    };

    return (
        <Form
            name='basic'
            size='large'
            form={form}
            labelCol={{
                span: 4,
            }}
            wrapperCol={{
                span: 18,
            }}
            onValuesChange={onValuesChange}
            autoComplete='off'
        >
            <Form.Item
                label='ID'
                name='id'
                rules={[
                    {
                        required: true,
                        message: 'Необходимо указать ID формы',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label='Имя формы'
                name='name'
                rules={[
                    {
                        required: true,
                        message: 'Необходимо добавить имя формы',
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                wrapperCol={{
                    offset: 6,
                    span: 16,
                }}
            >
                <div className={styles.buttonContainer}>
                    <Button className={styles.formButton} type='primary' onClick={handleSubmit} disabled={!isFildsFill} loading={loading}>
                        Добавить форму
                    </Button>
                </div>
            </Form.Item>
        </Form>
    );
}
